import {post} from './http'
let baseUrl = '/api/meas/admin/resource/course'
// 获取课程列表
export const getCourseList = data => post(`${baseUrl}/getCourseList`, data)
// 维护课程信息
export const saveCourse = data => post(`${baseUrl}/saveCourse`, data)
// 修改课程状态
export const updateCourseStatus = data => post(`${baseUrl}/updateCourseStatus`, data)
// 获取课程详情
export const getCourseDetails = data => post(`${baseUrl}/getCourseDetails`, data)
// 获取章节树列表
export const getCourseSectionTree = data => post(`${baseUrl}/getCourseSectionTree`, data)
// 新增修改课程章信息
export const saveCourseSection = data => post(`${baseUrl}/saveCourseSection`, data)
// 获取章对应的节的详细信息
export const getCourseSectionTaskDetails = data => post(`${baseUrl}/getCourseSectionTaskDetails`, data)
// 修改章顺序
export const saveCourseSectionIndex = data => post(`${baseUrl}/saveCourseSectionIndex`, data)
// 新增修改课程章的节信息
export const saveCourseSectionTask = data => post(`${baseUrl}/saveCourseSectionTask`, data)
// 修改章对应节的顺序
export const saveCourseSectionTaskIndex = data => post(`${baseUrl}/saveCourseSectionTaskIndex`, data)
// 删除章信息
export const updateSectionStatus = data => post(`${baseUrl}/updateSectionStatus`, data)
// 删除章对应的节信息
export const updateSectionTaskStatus = data => post(`${baseUrl}/updateSectionTaskStatus`, data)